import $ from 'jquery';
import dom from './dom';

const SCROLLED = 'scrolled';
const scrollProgress = () => {
  const progressBar = $('.c-scrpr');
  const post = $('.c-post');

  if (progressBar) {
    let offsetBottom = dom.$body.outerHeight() - post.outerHeight();
    const comments = $('.c-comments');
    const globals = {
      windowScrollTop: dom.$win.scrollTop(),
      windowOuterHeight: dom.$win.outerHeight(),
      bodyHeight: dom.$doc.height(),
    };

    const onResize = () => {
      offsetBottom = dom.$body.outerHeight() - post.outerHeight();
      if (comments.length) {
        offsetBottom += comments.outerHeight();
      }

      globals.windowScrollTop = dom.$win.scrollTop();
      globals.windowOuterHeight = dom.$win.outerHeight();
      globals.bodyHeight = dom.$doc.height();
    };
    onResize();

    dom.$win.on('resize', onResize);
    dom.$win.on('load', onResize);

    const bindWindowScroll = () => {
      dom.$win.on('scroll touchmove', () => {
        globals.windowScrollTop = dom.$win.scrollTop();
        globals.windowOuterHeight = dom.$win.outerHeight();
        globals.bodyHeight = dom.$doc.height();

        const total =
          (globals.windowScrollTop /
            (globals.bodyHeight - globals.windowOuterHeight - offsetBottom)) *
          100;
        progressBar.css('width', `${total}%`);
      });
    };

    bindWindowScroll();

    const total =
      (globals.windowScrollTop /
        (globals.bodyHeight - globals.windowOuterHeight - offsetBottom)) *
      100;
    progressBar.css('width', `${total}%`);

    dom.$win.on('scroll touchmove', () => {
      if (dom.$win.scrollTop() > 10) {
        dom.$body.addClass(SCROLLED);
      } else {
        dom.$body.removeClass(SCROLLED);
      }
    });
  }
};
export default scrollProgress;



// WEBPACK FOOTER //
// ./src/scripts/modules/scroll-progress.js